import React, { Component, Fragment } from "react";
import ConfirmButton from "./../../../components/buttons/ConfirmButton";
import Modal from "./../../../components/modalComponent/ModalComponent";
import ImportFormContainer from "../../ImportFormContainer";
import AuthRender from "../../AuthRender";
import { SERVICES, ACCESS } from "./../../../configs/constants";
class ImportSector extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showModal: false,
		};
	}

	render() {
		return (
			<Fragment>
				<Modal
					title="Importer un secteur"
					showModal={this.state.showModal}
					closeModal={() => this.setState({ showModal: false })}
					{...this.props}
				>
					<ImportFormContainer
						{...this.props}
						title="secto"
						importUri={"secto"}
					/>
				</Modal>
				<AuthRender service={SERVICES.Secto} access={["creation"]}>
					<div class="p-mrg-right">
						<ConfirmButton
							label="Importer un secteur"
							large={true}
							onClick={() => this.setState({ showModal: true })}
						/>
					</div>
				</AuthRender>
			</Fragment>
		);
	}
}

export default ImportSector;



// WEBPACK FOOTER //
// src/containers/metier/sectors/ImportSector.js